<template>
  <SessionSlide
    ref="slide"
    :id="'slide' + props.index"
    visual-position="fixed"
    :class="{
      'slide-after-activity': !isDisplayed,
      'submitted-mapping': isDisplayed,
    }"
    :data-test="`session-slide-${index}`"
  >
    <template #text>
      <SlideText :text="prismicSlice.primary.text_body" />
    </template>
    <template #visual>
      <VisualPositioningCanvas>
        <CmsImg v-if="imageExists" ref="visual" class="slide-image" :src="image" />
      </VisualPositioningCanvas>
    </template>
  </SessionSlide>
</template>

<script setup lang="ts">
import { computed, ref, watch, watchEffect } from "vue";
import SessionSlide from "../../sessions/session-slide.vue";
import VisualPositioningCanvas from "../../sessions/visual-positioning-canvas.vue";
import CmsImg from "../cms-img.vue";
import { CmsSessionSlideWithTextAndImage } from "../../../services/cms/cms-type-definitions";
import { PrismicSliceWithData } from "../../../views/cms/cms-session.vue";
import SlideText from "./slide-text.vue";
import pinia from "../../../stores";
import { useCmsSessionStore } from "../../../stores/useCmsSessionStore";
import { useToggle } from "../../../composables/useToggle";

const props = defineProps<{ slice: PrismicSliceWithData; index: number }>();

const cmsSessionStore = useCmsSessionStore(pinia());

const { state: isDisplayed, toggleState: toggleIsDisplayed } = useToggle(false);

const prismicSlice = computed<CmsSessionSlideWithTextAndImage>(() => {
  return props.slice.prismicSlice as CmsSessionSlideWithTextAndImage;
});

const image = computed(() => prismicSlice.value.primary.image);
const imageExists = computed(() => !!image.value?.url);

watchEffect(() => {
  if (!isDisplayed.value && cmsSessionStore.sectionsToDisplay.includes(props.slice.section)) {
    toggleIsDisplayed();
  }
});

// These 3 refs need to be exposed so that cms-session can apply animations to them
const visual = ref<InstanceType<typeof CmsImg> | null>(null);
const slide = ref<InstanceType<typeof SessionSlide> | null>(null);
const visualDiv = computed(() => slide?.value?.visualDiv);

defineExpose({
  visualDiv,
  visual,
  slide,
});
</script>
